import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
function replaceAt(string, index, replace) {
  return string.substring(0, index) + replace + string.substring(index + 1);
}
export function applyInsertMode(newState, oldState, userInput, maskOptions, handleValueChangeCallback) {
  var _context;
  const isEmpty = _everyInstanceProperty(_context = newState.value.split('')).call(_context, (char, index) => {
    var _context2;
    return char === maskOptions.maskChar || _includesInstanceProperty(_context2 = maskOptions.permanents).call(_context2, index);
  });
  if (isEmpty || oldState.selection === null || newState.selection === null || !maskOptions.maskChar) {
    if (newState.value !== oldState.value) {
      handleValueChangeCallback({
        target: {
          value: newState.value
        }
      });
    }
    return newState;
  }
  let newValue = newState.value;
  if (userInput !== null) {
    newValue = newState.value;
    let startIndex = oldState.selection.start;
    let endIndex = newState.selection.end;
    while (endIndex < newValue.length) {
      var _context3, _context4;
      if (_includesInstanceProperty(_context3 = maskOptions.permanents).call(_context3, endIndex)) {
        endIndex += 1;
      } else if (_includesInstanceProperty(_context4 = maskOptions.permanents).call(_context4, startIndex)) {
        startIndex += 1;
      } else {
        newValue = replaceAt(newValue, endIndex, oldState.value.charAt(startIndex));
        endIndex += 1;
        startIndex += 1;
      }
    }
  } else if (newState.value !== oldState.value && oldState.selection.end < newValue.length) {
    newValue = oldState.value;
    let startIndex = newState.selection.start;
    let endIndex = oldState.selection.end;
    if (endIndex === startIndex) {
      endIndex += 1;
    }
    while (endIndex < newValue.length) {
      var _context5, _context6;
      if (_includesInstanceProperty(_context5 = maskOptions.permanents).call(_context5, endIndex)) {
        endIndex += 1;
      } else if (_includesInstanceProperty(_context6 = maskOptions.permanents).call(_context6, startIndex)) {
        startIndex += 1;
      } else {
        newValue = replaceAt(newValue, startIndex, newValue.charAt(endIndex));
        endIndex += 1;
        startIndex += 1;
      }
    }
    while (startIndex < newValue.length) {
      var _context7;
      if (_includesInstanceProperty(_context7 = maskOptions.permanents).call(_context7, startIndex)) {
        startIndex += 1;
      } else {
        newValue = replaceAt(newValue, startIndex, maskOptions.maskChar);
        startIndex += 1;
      }
    }
  }
  return {
    value: newValue,
    selection: newState.selection
  };
}